let EveryoneHolidaysItems = [
    {
        id: 1,
        itemTitle: 'All-Inclusive Getaways under £499pp',
        itemSubTitle: '7 nights from',
        itemPrice: '£499'
    },
    {
        id: 2,
        itemTitle: 'Beach Escapes under £249pp',
        itemSubTitle: '4 nights from',
        itemPrice: '£249'
    },
    {
        id: 3,
        itemTitle: 'Scenic Cruise Experiences under £799pp',
        itemSubTitle: '7 nights from',
        itemPrice: '£799'
    },
    {
        id: 4,
        itemTitle: 'City Break Deals under £199pp',
        itemSubTitle: '2 nights from',
        itemPrice: '£199'
    },
    {
        id: 5,
        itemTitle: 'Hotel-Only Offers under £99pp',
        itemSubTitle: '2 nights from',
        itemPrice: '£99'
    },
    {
        id: 6,
        itemTitle: 'Winter Escape Packages under £299pp',
        itemSubTitle: '5 nights from',
        itemPrice: '£299'
    }
];

export default EveryoneHolidaysItems;
